// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1Tfql","item":"style_item__1CVGw","number":"style_number__2ClrU","label":"style_label__yyzIU","img":"style_img__1r0ow","allbtn":"style_allbtn__1gGqD"};